import React from 'react';
import { Eye, Pencil } from 'lucide-react';

const ChatModeToggle = ({ mode, setMode }) => (
  <div className="px-4 py-2 border-b border-slate-100 bg-slate-50">
    <div className="flex gap-1 bg-white p-0.5 rounded-lg border border-slate-200">
      <button
        onClick={() => setMode('ask')}
        className={`flex-1 flex items-center justify-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium transition-colors ${
          mode === 'ask'
            ? 'bg-[#2B8FD8] text-white shadow-sm'
            : 'text-slate-500 hover:text-slate-700'
        }`}
      >
        <Eye className="h-3 w-3" />
        Ask Questions
      </button>
      <button
        onClick={() => setMode('suggest')}
        className={`flex-1 flex items-center justify-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium transition-colors ${
          mode === 'suggest'
            ? 'bg-amber-500 text-white shadow-sm'
            : 'text-slate-500 hover:text-slate-700'
        }`}
      >
        <Pencil className="h-3 w-3" />
        Request Changes
      </button>
    </div>
  </div>
);

export default ChatModeToggle;
